exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:768px){h2[data-v-b8e560a2]{font-size:24px}h4[data-v-b8e560a2]{font-size:20px}}.button-group[data-v-b8e560a2]{text-align:right}.button-group-optional[data-v-b8e560a2]{text-align:left}.edit-icon-button[data-v-b8e560a2]{position:absolute;right:0}.edit-button-container[data-v-b8e560a2]{position:relative}.edit-button-container .edit-button.no-notes[data-v-b8e560a2]{top:-14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b8e560a2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/global-dialogs/InfoDialog.vue
// module id = 624
// module chunks = 38